/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * Accessibility: strip transparent-color values from inline styles.
   *
   * The theme's AOS-style animation system sets inline
   * `color: rgba(R, G, B, 0)` on elements like `.badge-box.sale-box`
   * (sale tags), `.hero__title` headings, and other animated content.
   *
   * The CSS overrides in custom.css already force the *computed* color
   * to be visible (so users see correct text), and axe-core / Lighthouse
   * pass because they evaluate computed style. But WAVE parses the
   * inline `style="..."` attribute string literally and still flags the
   * transparent color as "very low contrast".
   *
   * Remove the `color: rgba(R, G, B, 0)` declaration from any element's
   * inline style after page load (and again after a delay to catch
   * lazy-rendered carousels). After this runs the inline style is clean
   * and WAVE has nothing to flag.
   */
  function stripTransparentInlineColor() {
    var transparentRe = /color\s*:\s*rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*0\s*\)\s*;?\s*/gi;
    var elements = document.querySelectorAll('[style*="rgba"]');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var s = el.getAttribute('style');
      if (s && transparentRe.test(s)) {
        transparentRe.lastIndex = 0;
        el.setAttribute('style', s.replace(transparentRe, '').trim());
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripTransparentInlineColor);
  } else {
    stripTransparentInlineColor();
  }
  // Re-run a few times to catch elements rendered by lazy-loaded carousels
  // (product card sale badges, related-product sliders, etc.).
  setTimeout(stripTransparentInlineColor, 500);
  setTimeout(stripTransparentInlineColor, 1500);
  setTimeout(stripTransparentInlineColor, 3500);

  /*
   * Accessibility: rewrite third-party "broken" href values that WAVE flags.
   *
   * Apps like PhotoSwipe, Judge.me, and Accessibly inject elements like
   * <a href="#">...</a> or <a href="#accessibly-trigger">...</a> where the
   * target ID doesn't exist on the page. WAVE flags these as "broken link"
   * errors. We can't modify those apps' source, but we can rewrite the href
   * to point to a valid in-page anchor so WAVE accepts them. The third-party
   * click handlers attach to the element by selector/class (not by href
   * value), so their behavior is unaffected.
   */
  function fixThirdPartyBrokenLinks() {
    var NOOP_ID = 'a11y-noop-target';
    if (!document.getElementById(NOOP_ID)) {
      var noop = document.createElement('div');
      noop.id = NOOP_ID;
      noop.setAttribute('aria-hidden', 'true');
      noop.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
      document.body.appendChild(noop);
    }

    var selectors = [
      'a.pswp__caption-close[href="#"]',
      'a.jdgm-write-rev-link[href="#"]',
      'a.jdgm-random-link[href="#"]',
      'a[href="#accessibly-trigger"]'
    ];

    selectors.forEach(function(sel) {
      var els;
      try { els = document.querySelectorAll(sel); } catch(e) { return; }
      els.forEach(function(el) {
        if (el.getAttribute('data-a11y-fixed') === '1') return;
        el.setAttribute('data-a11y-fixed', '1');
        el.setAttribute('href', '#' + NOOP_ID);
        if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      });
    });

    /*
     * Empty-link fix for Judge.me review widget links.
     * jdgm-popup-card__full-rev-link and jdgm-full-rev__product-button
     * render as icon-only with empty innerHTML, so WAVE flags them as
     * "empty link" errors. Add aria-labels derived from context.
     */
    document.querySelectorAll('a.jdgm-popup-card__full-rev-link').forEach(function(a) {
      if (a.getAttribute('aria-label')) return;
      if ((a.textContent || '').trim()) return;
      a.setAttribute('aria-label', 'Read full customer review');
    });
    document.querySelectorAll('a.jdgm-full-rev__product-button').forEach(function(a) {
      if (a.getAttribute('aria-label')) return;
      if ((a.textContent || '').trim()) return;
      var href = a.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/#?]+)/);
      var productSlug = match ? match[1].replace(/-/g, ' ') : '';
      a.setAttribute('aria-label', productSlug ? 'View ' + productSlug + ' reviews' : 'View product reviews');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixThirdPartyBrokenLinks);
  } else {
    fixThirdPartyBrokenLinks();
  }
  // Re-run for lazy-loaded third-party content (Judge.me + Accessibly often
  // inject elements after initial load).
  setTimeout(fixThirdPartyBrokenLinks, 1000);
  setTimeout(fixThirdPartyBrokenLinks, 3000);
  setTimeout(fixThirdPartyBrokenLinks, 6000);

  /*
   * PopConvert popup — flex-center CTA buttons (Shadow DOM workaround).
   *
   * Reported by Stefan: the "YES!" CTA on the homepage email-capture
   * popup renders with its text in the top-left of an oversized box.
   *
   * The earlier fix (commit 29782de) added flex-center rules to
   * `custom.css` scoped to `#pop-convert-app button, ...`. Those rules
   * never reached the button because the app mounts its Vue popup
   * inside a Shadow DOM rooted at `#pop-convert-app`. Theme stylesheets
   * cannot cross the shadow boundary, so the CSS workaround silently
   * no-ops. (The CSS in custom.css is left in place as a no-op safety
   * net in case PopConvert ever stops using Shadow DOM.)
   *
   * Fix: append a small <style> with the same flex-center rules INTO
   * the shadow root so they apply alongside the app's own encapsulated
   * CSS. Idempotent (only injects once), and silently no-ops if the
   * app isn't on the page.
   *
   * Selectors target the rendered popup form (templates load with
   * `zpa-crm-popup-form` / `zpa-crm-popup-body` class hooks plus
   * `[data-popup-content]`) — broad enough to catch any CTA the
   * merchant configures, while excluding the close-X button by class.
   */
  function injectPopConvertShadowCss() {
    var host = document.getElementById('pop-convert-app');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.querySelector('style[data-ba-popconvert-fix]')) return true;
    var s = document.createElement('style');
    s.setAttribute('data-ba-popconvert-fix', '');
    s.textContent =
      '.zpa-crm-popup-form button:not(.zpa-popup-btn-close),' +
      '.zpa-crm-popup-form [role="button"],' +
      '.zpa-crm-popup-form input[type="submit"],' +
      '.zpa-crm-popup-form input[type="button"],' +
      '.zpa-crm-popup-body button:not(.zpa-popup-btn-close),' +
      '.zpa-crm-popup-body [role="button"],' +
      '.zpa-crm-popup-body input[type="submit"],' +
      '.zpa-crm-popup-body input[type="button"],' +
      '[data-popup-content] button:not(.zpa-popup-btn-close),' +
      '[data-popup-content] [role="button"],' +
      '[data-popup-content] input[type="submit"],' +
      '[data-popup-content] input[type="button"]' +
      '{display:flex!important;align-items:center!important;' +
      'justify-content:center!important;text-align:center!important;}';
    host.shadowRoot.appendChild(s);
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectPopConvertShadowCss);
  } else {
    injectPopConvertShadowCss();
  }
  // PopConvert's shadow root attaches lazily and the merchant's popup
  // may also be triggered minutes after page load. Retry briefly so we
  // catch any timing variation without polling forever.
  setTimeout(injectPopConvertShadowCss, 500);
  setTimeout(injectPopConvertShadowCss, 1500);
  setTimeout(injectPopConvertShadowCss, 4000);
  setTimeout(injectPopConvertShadowCss, 10000);

  /*
   * Klaviyo signup-form modal — flex-center CTA buttons.
   *
   * Reported by Stefan via Slack: the "YES!" CTA on the
   * "SIGN UP FOR EMAIL AND SAVE!" / "Want 20% off your entire order?"
   * popup renders with text pinned top-left of an oversized box.
   *
   * (Prior attempts targeted #pop-convert-app — wrong app. The
   * modal is rendered by Klaviyo, identifiable by `kl-*` class
   * prefixes and the `kl-private-reset-css-*` reset marker that
   * Klaviyo applies to every element it owns.)
   *
   * Klaviyo's elements live in the regular DOM (not a shadow root),
   * so the matching declarations in custom.css already apply with
   * !important. The reason we still need JS: Klaviyo's runtime
   * re-applies inline styles after the popup mounts and after its
   * open animation finishes. Stylesheet `!important` cannot beat
   * inline `!important` (inline = 1000 specificity), so the CSS
   * loses on later frames.
   *
   * Fix: a MutationObserver that runs `style.setProperty(prop,
   * value, 'important')` on every Klaviyo CTA as soon as it appears
   * and re-applies on any `style`/`class` mutation. Inline + !important
   * is the maximum CSS specificity — nothing Klaviyo can do at
   * runtime outranks it.
   *
   * Class hashes change between Klaviyo versions, so we hook on the
   * stable `kl-private-reset-css-*` marker and use a `:not(...close)`
   * filter to leave the close-X alone.
   */
  var KLAVIYO_CTA_SELECTOR = [
    '[class*="kl-private-reset-css-"] button:not([aria-label*="close" i]):not([class*="close" i])',
    '[class*="kl-private-reset-css-"] [role="button"]:not([aria-label*="close" i]):not([class*="close" i])',
    '[class*="kl-private-reset-css-"] input[type="submit"]',
    '[class*="kl-private-reset-css-"] input[type="button"]'
  ].join(',');

  function applyKlaviyoCtaInlineFix() {
    var buttons;
    try { buttons = document.querySelectorAll(KLAVIYO_CTA_SELECTOR); }
    catch (e) { return; }
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      // Idempotency guard — break observer feedback loop.
      if (b.style.display !== 'flex' ||
          b.style.alignItems !== 'center' ||
          b.style.justifyContent !== 'center' ||
          b.style.textAlign !== 'center') {
        b.style.setProperty('align-items', 'center', 'important');
        b.style.setProperty('justify-content', 'center', 'important');
        b.style.setProperty('text-align', 'center', 'important');
      }
      // Also center text in immediate descendants the merchant
      // may have aligned left via the form editor.
      var kids = b.querySelectorAll('p, span, div');
      for (var j = 0; j < kids.length; j++) {
        var k = kids[j];
        if (k.style.textAlign === 'center') continue;
        k.style.setProperty('text-align', 'center', 'important');
      }
    }

    // Center the button within its parent row stack. Klaviyo's form
    // renderer sets `justify-content: flex-start` inline on both
    // form-row and form-component containers, so we need to override
    // BOTH for the small CTA to visually land in the middle of the
    // row (form-component is content-sized, form-row is wider; the
    // form-component sits at the left edge of form-row unless we
    // override form-row).
    //
    // SCOPING: only override containers that have a Klaviyo CTA
    // button as a descendant. Walk from each CTA button up to its
    // ancestor form-row + form-component. This avoids touching
    // unrelated rows like the email-input step.
    var ctaButtons;
    try {
      ctaButtons = document.querySelectorAll(
        'button.klaviyo-form-button, button[class*="klaviyo-form-button"]'
      );
    } catch (e) { return; }
    for (var c = 0; c < ctaButtons.length; c++) {
      var btn = ctaButtons[c];
      var ancestors = [
        btn.closest('[data-testid="form-component"]'),
        btn.closest('[data-testid="form-row"]')
      ];
      for (var a = 0; a < ancestors.length; a++) {
        var el = ancestors[a];
        if (!el) continue;
        if (el.style.justifyContent === 'center') continue;
        el.style.setProperty('justify-content', 'center', 'important');
      }
    }
  }

  var klaviyoObserverInstalled = false;
  function installKlaviyoObserver() {
    if (klaviyoObserverInstalled) return;
    applyKlaviyoCtaInlineFix();
    var obs = new MutationObserver(function() { applyKlaviyoCtaInlineFix(); });
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    klaviyoObserverInstalled = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installKlaviyoObserver);
  } else {
    installKlaviyoObserver();
  }
  // Klaviyo loads its form asynchronously and can re-render on
  // navigation. The observer above catches everything once installed,
  // but a couple of explicit re-applies right after page load are
  // cheap insurance.
  setTimeout(applyKlaviyoCtaInlineFix, 1000);
  setTimeout(applyKlaviyoCtaInlineFix, 3000);
  setTimeout(applyKlaviyoCtaInlineFix, 8000);

  /*
   * Product "Notify Me when available" modal — wire up Shopify hCaptcha.
   *
   * Reported by Bryan via Slack: on a sold-out PDP, clicking "NOTIFY ME"
   * after filling in an email does nothing visible — the click is
   * accepted (focus lands on the button) but the form never moves
   * forward.
   *
   * Root cause: Shopify rolled out hCaptcha protection on every
   * {%- form 'contact' -%}. At the top level of a page, Shopify
   * auto-detects the form and wires it up via
   * `Shopify.captcha.protect(form)`. That call:
   *   - injects the <div class="h-captcha"> widget into the form,
   *   - adds a hidden <textarea name="h-captcha-response">,
   *   - REPLACES `form.submit` with a wrapper that runs invisible
   *     hCaptcha first and only then calls the native submit (so the
   *     POST to /contact carries the captcha token).
   *
   * The notify-me form is rendered inside
   *   <product-form>{%- form 'product' -%} … {%- form 'contact' -%} …
   * — two nested {%- form -%} blocks. Shopify's auto-detection misses
   * the inner /contact form (the nested-form HTML structure isn't on
   * the scan path), so `protect()` is never called. Then
   * product-notification.js's submit handler does
   * `preventDefault(); …; notificationForm.submit();` — the
   * programmatic submit posts to /contact with no captcha token and
   * Shopify rejects it ("Missing CAPTCHA token"). To Bryan it looks
   * like the button is broken.
   *
   * Fix: call `Shopify.captcha.protect()` ourselves on every
   * `form[data-notification-form]` once the Shopify global is loaded.
   * Idempotent (gated by data-notify-captcha-protected) and silently
   * no-ops if the global isn't ready — we retry on a short schedule
   * so we catch the case where Shopify's storefront bundle loads after
   * DOMContentLoaded.
   *
   * Why this is in custom.js and not in product-notification.js or the
   * notification-form snippet: those files are theme source and get
   * clobbered on Shopify-pushed theme updates. custom.js is the
   * override seam ([[bryan-anthonys-theme]]).
   */
  function protectNotifyMeForms() {
    var capi = window.Shopify && window.Shopify.captcha;
    if (!capi || typeof capi.protect !== 'function') return false;
    var forms;
    try { forms = document.querySelectorAll('form[data-notification-form]'); }
    catch (e) { return false; }
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.getAttribute('data-notify-captcha-protected') === '1') continue;
      f.setAttribute('data-notify-captcha-protected', '1');
      try { capi.protect(f); } catch (e) {}
    }
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', protectNotifyMeForms);
  } else {
    protectNotifyMeForms();
  }
  // Shopify's storefront bundle (which exposes Shopify.captcha) and the
  // product section can both arrive after DOMContentLoaded. Retry on a
  // short schedule so we catch either ordering.
  setTimeout(protectNotifyMeForms, 500);
  setTimeout(protectNotifyMeForms, 2000);
  setTimeout(protectNotifyMeForms, 6000);

  /*
   * HENG Notify! BIS — override the "Notify me" button label.
   *
   * Taylor wants the BIS button on sold-out PDPs to read "Notify me
   * when restocked" instead of HENG's default "Notify me", which is
   * vague (especially next to ADD TO WISHLIST in the same UI region —
   * both could mean "save this for later"). The "when restocked"
   * phrasing makes the customer promise explicit.
   *
   * Cleanest long-term fix is to change the label in HENG's dashboard
   * (Notify! Back in Stock → Translations → product page button text);
   * that updates `_ReStockConfig.ui_contents[].notify_me_contents[].
   * button_text` server-side and survives every theme deploy. This
   * shim ships the new copy immediately without waiting on a HENG
   * dashboard round-trip.
   *
   * The button is HENG-rendered, identifiable by class
   * `.restock-alerts-notify-button`. HENG re-renders it on variant
   * change (e.g., swapping from in-stock Gold to OOS Silver on a PDP),
   * so a one-shot textContent assignment isn't enough.
   *
   * Race condition fix history (original PR #45 → fix-up):
   *   First pass guarded the override with a regex that ONLY matched
   *   HENG's pristine default ("Notify me" or "Notify me!"). HENG's
   *   framework reconciles after our textContent change and appends a
   *   fresh "Notify me" text node to the button — `textContent` then
   *   reads "Notify me when restockedNotify me". The original regex no
   *   longer matched that dirty state, so the observer skipped and
   *   left the concatenated text in place. Taylor caught this on the
   *   live storefront after PR #45 merged (screenshot 2026-05-21).
   *
   *   This pass relaxes the gate: we override if the current text
   *   isn't EXACTLY our target AND contains "notify me" anywhere,
   *   so the concatenated/dirty state also resets to the clean
   *   target. Still guarded against `out of stock` / `click here`
   *   text (HENG's "not selectable variants" label, different
   *   functional meaning).
   *
   * Spanish/other-language locales fall through unchanged — HENG's
   * ui_contents has translations for "Notify me" → "Notificarme" etc.
   * which this shim doesn't touch. Bryan Anthonys ships predominantly
   * English; if other locales become primary we revisit.
   */
  var HENG_NOTIFY_BTN_SELECTOR =
    '.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button';
  var HENG_NOTIFY_NEW_TEXT = 'Notify me when restocked';
  // We DON'T touch the not-selectable-variants label ("Out of stock?
  // Click here") — different functional meaning, different UX.
  var HENG_NOTIFY_PRESERVE = /out of stock|click here/i;

  function overrideHengNotifyButtonText() {
    var btns;
    try { btns = document.querySelectorAll(HENG_NOTIFY_BTN_SELECTOR); }
    catch (e) { return; }
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var t = (b.textContent || '').trim();
      // Already overridden — skip (breaks observer feedback loop).
      if (t === HENG_NOTIFY_NEW_TEXT) continue;
      // Not the not-selectable-variants label.
      if (HENG_NOTIFY_PRESERVE.test(t)) continue;
      // Match "Notify me" anywhere — catches both HENG's pristine
      // "Notify me" and the concatenated "Notify me when restockedNotify
      // me" state that HENG's framework can produce by appending its
      // own text node after our override.
      if (!/notify\s*me/i.test(t)) continue;
      b.textContent = HENG_NOTIFY_NEW_TEXT;
    }
  }

  var hengObserverInstalled = false;
  function installHengNotifyObserver() {
    if (hengObserverInstalled) return;
    overrideHengNotifyButtonText();
    var obs = new MutationObserver(function() {
      overrideHengNotifyButtonText();
    });
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    hengObserverInstalled = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installHengNotifyObserver);
  } else {
    installHengNotifyObserver();
  }
  // HENG's SDK initializes asynchronously and re-renders on variant
  // change; the observer above catches everything once installed, but
  // a couple of explicit re-applies right after page load are cheap
  // insurance (mirrors the Klaviyo helper pattern above).
  setTimeout(overrideHengNotifyButtonText, 1000);
  setTimeout(overrideHengNotifyButtonText, 3000);
  setTimeout(overrideHengNotifyButtonText, 8000);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
